"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var Terms = _interopRequireWildcard(require("self-service-api/constants/Terms"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: 25px;\n  margin-bottom: 20px;\n  text-align: center;\n\n  button,\n  a {\n    display: block;\n    min-width: 200px;\n    width: 100%;\n    line-height: 24px;\n  }\n\n  a {\n    padding-top: 16px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 18px;\n  font-weight: 400;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 26px;\n  font-weight: 600;\n  display: inline-flex;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 14px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", " !important;\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 45px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 38px;\n  font-weight: bold;\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-weight: 600;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 20px;\n  text-transform: uppercase;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BillingCaption = _styledComponents.default.div.withConfig({
  displayName: "CalculatorPriceDisplayTile__BillingCaption",
  componentId: "sc-1xnbl8u-0"
})(_templateObject(), _responsiveBreakpoints.default.tablet(_templateObject2()));

var MonthlyPriceDisplay = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "CalculatorPriceDisplayTile__MonthlyPriceDisplay",
  componentId: "sc-1xnbl8u-1"
})(_templateObject3(), _responsiveBreakpoints.default.tablet(_templateObject4()));
var PriceBreakdownLink = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "CalculatorPriceDisplayTile__PriceBreakdownLink",
  componentId: "sc-1xnbl8u-2"
})(_templateObject5(), _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject6()));

var StyledTermMessage = _styledComponents.default.div.withConfig({
  displayName: "CalculatorPriceDisplayTile__StyledTermMessage",
  componentId: "sc-1xnbl8u-3"
})(_templateObject7());

var StyledPriceText = _styledComponents.default.span.withConfig({
  displayName: "CalculatorPriceDisplayTile__StyledPriceText",
  componentId: "sc-1xnbl8u-4"
})(_templateObject8());

var StyledCTAsWrapper = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "CalculatorPriceDisplayTile__StyledCTAsWrapper",
  componentId: "sc-1xnbl8u-5"
})(_templateObject9());

var getBreakdownLinkGAClassName = function getBreakdownLinkGAClassName(gaTrackingId) {
  return (0, _publicPageUrls.getGAClassName)(gaTrackingId + "-pricing-breakdown");
};

var CalculatorPriceDisplayTile = function CalculatorPriceDisplayTile(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      activeTerm = _ref.activeTerm,
      gaTrackingId = _ref.gaTrackingId,
      onViewPriceBreakdownClick = _ref.onViewPriceBreakdownClick,
      costToGetStarted = _ref.costToGetStarted,
      monthlyCost = _ref.monthlyCost,
      ctasComponent = _ref.ctasComponent,
      _ref$showTotalPriceAs = _ref.showTotalPriceAsterisk,
      showTotalPriceAsterisk = _ref$showTotalPriceAs === void 0 ? false : _ref$showTotalPriceAs,
      requiredOnboardingSubtext = _ref.requiredOnboardingSubtext;
  return _react.default.createElement("div", null, _react.default.createElement(BillingCaption, {
    className: "m-bottom-5 m-top-5 p-x-8"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.billingCaptions." + activeTerm
  })), _react.default.createElement("div", {
    className: "m-bottom-8"
  }, _react.default.createElement(MonthlyPriceDisplay, {
    currencyCode: activeCurrencyCode,
    price: monthlyCost,
    dataSelenium: "calculator-monthly-price"
  }), _react.default.createElement(StyledTermMessage, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonth"
  }))), _react.default.createElement(BillingCaption, {
    className: "p-x-12 m-bottom-2"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.estimatedCostText"
  })), _react.default.createElement(StyledPriceText, null, _react.default.createElement(_PriceDisplay.default, {
    currencyCode: activeCurrencyCode,
    price: costToGetStarted,
    dataSelenium: "calculator-total-price"
  }), showTotalPriceAsterisk && _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.requiredOnboardingSubtext.asterisk"
  })), _react.default.createElement(StyledCTAsWrapper, {
    direction: "column",
    justify: "center",
    align: "center"
  }, ctasComponent), _react.default.createElement("div", null, _react.default.createElement(PriceBreakdownLink, {
    onClick: onViewPriceBreakdownClick,
    underline: true,
    className: getBreakdownLinkGAClassName(gaTrackingId)
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceBreakdown.link",
    className: getBreakdownLinkGAClassName(gaTrackingId)
  }))), _react.default.createElement("div", {
    className: "m-top-6 p-x-5"
  }, requiredOnboardingSubtext));
};

CalculatorPriceDisplayTile.propTypes = {
  activeTerm: _propTypes.default.oneOf(Object.values(Terms || {})).isRequired,
  activeCurrencyCode: _propTypes.default.string.isRequired,
  onViewPriceBreakdownClick: _propTypes.default.func.isRequired,
  costToGetStarted: _propTypes.default.number.isRequired,
  monthlyCost: _propTypes.default.number.isRequired,
  ctasComponent: _propTypes.default.node.isRequired,
  gaTrackingId: _propTypes.default.string.isRequired,
  showTotalPriceAsterisk: _propTypes.default.bool,
  requiredOnboardingSubtext: _propTypes.default.node
};
var _default = CalculatorPriceDisplayTile;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/CalculatorPriceDisplayTile.js
// module id = 484
// module chunks = 5 6